const products = [
  /*
  {
    id: 1,
    name: "MixMastrr Blender",
    price: 29.99,
    img: "TESTDEMO/valve-tq.jpg",
    additionalImages: [
      "/TESTDEMO/valve-front.JPG",
      "/TESTDEMO/valve-tq.JPG"
    ],
    specifications: {
      "Power": "500W",
      "Speed Settings": "5 levels",
      "Capacity": "1.5L",
      "Material": "Stainless Steel Blades",
      "Weight": "2.5 kg",
    },
    description: "The MixMastrr Blender is our new state of the ark oxygen delivery device. This device can provide flows up to 80lpm for the Low-flow unit and up to 120lpm for the High-Flow unit. The MixMastrr blender can be configured with different porting for various applications. For more information on technical specs and product options view the datasheet below."
  },
  */
  /*
   {
     id: 2,
     name: "Tanks",
     price: 49.99,
     img: "TESTDEMO/tanks.JPG",
     additionalImages: [
       "TESTDEMO/tanks-1.JPG",
       "TESTDEMO/tanks-2.JPG",
       "TESTDEMO/tanks-3.JPG"
     ],
     specifications: {
       "Capacity": "10L",
       "Material": "Aluminum",
       "Pressure Rating": "3000 psi",
       "Weight": "4.2 kg",
       "Dimensions": "60cm x 20cm",
     },
     description: "These aluminum tanks are designed for high-pressure applications, featuring a capacity of 10 liters and a pressure rating of 3000 psi."
   },
   */
  {
    id: 1,
    name: "Flowmeter",
    price: 19.99,
    img: "TESTDEMO/flowmeter2.jpg",
    additionalImages: [
      "/TESTDEMO/flowmeter1.jpg",
      "/TESTDEMO/flowmeter2.jpg",
      "/TESTDEMO/flowmeter3.jpg",
      "/TESTDEMO/flowmeterbrochure.png"
    ],
    specifications: {
      "Flow Range": "1/32 lpm - 60 lpm",
      "Laser drilled Orifice plate with integrated filter": "20 micron Stainless Steel filter",
      "Material": "Anodized Aluminum",
      "Inlet + Outlet Connections": "Configurable inlet and outlet connections",
      "Operating Pressure": "100 psi max",
      "MRI Conditional": "Yes",
      "Orientation-independent": "Yes",
      "Custom Laser Etching": "Available upon request",
    },
    brochure: "/BROCHURES/B-Flowmeter (2024-05-14) (Rev. B).docx.pdf",
    description: "The Flotec medical gas Flowmeter features unique 12 position, non-gravity sensitive fixed orifices. The all metal component construction Flowmeter features a 30-micron sintered metal inlet filter, and a second internal 20-micron rotor filter. It effectively functions as a back pressure compensated device, based on the “Perfect Gas Law”. Flotec Flowmeters are ergonomically designed, and are available with a complete selection of inlet and outlet connections, including international fittings, and they feature Large View Windows with flow numerals that are permanently lased into the black anodized knob. The Flowmeter is lightweight, ergonomic, MRI conditional, all metal assembly, and are extraordinarily durable, like their brother regulators, they can withstand driving nails and cracking pecans. Available flows as low as 1/50th of a liter (20mL) through, and including, 60 LPM in any medical gas or gas blend. Custom flows and flow ranges are available at nominal charge - view get product info to download a more in-depth product specs sheet."
  },
  {
    id: 2,
    name: "Regulator",
    img: "TESTDEMO/ingage.jpg",
    description: "Choose the type of regulator best suited for your needs.",
    options: [
      {
        id: 6,
        name: "Ingage Regulator",
        img: "/TESTDEMO/P-DR81332.png",
        description: "Durable click-style regulator ideal for field use."
      },
      {
        id: 7,
        name: "RW Regulator",
        img: "/TESTDEMO/RR813.png",
        description: "A click style regulator with a physical pressure gauge and flow position readout."
      },
      {
        id: 3,
        name: "Pressure Reducer",
        img: "/TESTDEMO/P-DR510-pressure-reduce-no-bg.png",
        description: "Hand Tight style inlet knob with a physical PSI readout."
      },
    ]
  },
  {
    id: 3,
    name: "Pressure Reducer",
    price: 59.99,
    img: "TESTDEMO/P-DR510-pressure-reduce-no-bg.png",
    additionalImages: [
      "/TESTDEMO/P-DR5103-highqual.png",
      "/TESTDEMO/P-DR510-nexttoruler.png",
      "/TESTDEMO/P-DR510-pressure-reduce-no-bg.png"
    ],
    specifications: {
      "Material": "Anodized Aluminum and Plated Brass",
      "Internal Pressure Gauge": "Yes",
      "Shape": "Dodecagon (12-sided)",
      "Connection Type": "Configurable Inlet and Outlet connections in Hand Tight or Wrench Style",
      "Custom Laser Etching": "Available upon request",
      "MRI Conditional": "Yes",
    },

    description: "This pressure reducer is fully metal and lightweight with an all aluminum design. The reducer comes with One or Two DISS-1240 Check Valves and can be configured with a Hand Tight or Wrench style knobs."
  },
  {
    id: 4,
    name: "Mass Causality",
    price: 39.99,
    img: "TESTDEMO/masscass1.png",
    additionalImages: [
    ],
    specifications: {
      "Hose Length": "Configurable Lengths",
      "Flowmeter Options": "Configurable Flowmeter Models and Quantities",
      "Regulator Options": "Configurable Reguator Models and Quantities",
      "Connection Tee Options": "Live Swivel or Rigid Tee",
      "Use Cases": "Hospital Expansions, Mobile Tent Hospitals, Field Triage",
      "Case Options": "Soft Canvas Bag or Watertight Hard Case",
      "Mounting": "Lanyards for IV Poles or Railings",
    },
    brochure: "/BROCHURES/B-Mass Casualty Assembly (2024-02-05) (Rev. A).docx.pdf",
    description: "The Flotec Mass Causality Assembly is an oxygen distribution manifold incorporating from one to 20 Flowmeters that when used with Flotec's Pressure Reducer can deliver 150 LPM of total flow. The added space between each patient, or rehabbing Firefighter, provides for optimum care and less chaos during emergency situations. The custom length leader hose can be easily connected to the ambulance/or other gas source, while providing space for triage. The Mass Casualty Assembly is ideal for Hospital Capacity Expansions, Pop-Up or Mobile Tent Hospitals and Field Triage Scenarios where a single ambulance is able to supply six patients."
  },
  {
    id: 5,
    name: "Transfill Cascade",
    price: 89.99,
    img: "TESTDEMO/transfillcascade.png",
    additionalImages: [
      "/TESTDEMO/transfillcascadedrawing.png",
      "/TESTDEMO/transfillcascade.png",
      "/TESTDEMO/customtransfillcascadesystem.png",
    ],
    youtube: "https://youtu.be/gHZO_mTW9ww?si=ZMV4jq1_WBuO2pU-",
    specifications: {
      "Source Inlet Hoses": "Four (4) 36\" Stainless Steel Braided High Pressure Hoses w/ CGA 540 Hex Nut and CGA 540 Hand Tight Knurled Nut with O-ring",
      "Pressure Gauge Assembly": "Includes Check Valve and 100 PSI per minute Snubber Orifice (TCS-TCSCS)",
      "Inlet Valves": "Four (4) CGA 540 valves on 6\" threaded centers with two (2) mounting brackets",
      "Master Shutoff": "Between Source and Target sides",
      "Elbow Assembly": "Includes Gauge and one (1) mounting bracket",
      "Outlet Configuration": "One (1) CGA 540 Outlet pointing downward and one (1) CGA 540 Vent with silencer",
      "Target Outlet Hose": "One (1) 36\" Stainless Steel Braided High Pressure Hose with CGA 540 Hex Nut and Knurled Nut; includes CGA 540 to CGA 870 adapter",
      "Gauge Type": "Analog Pressure Gauge",
      "Pressure Range": "0 - 3000 psi",
      "Dial Size": "2.5 inch",
      "Material": "Stainless Steel",
      "Mounting": "Panel Mount"
    },
    brochure: "/BROCHURES/B-Transfill Cascade System (2025-04-24) (Rev. D).docx.pdf",
    description: (
      <>
        The Flotec Transfill Cascade System is a wall-mounted manifold designed for safely and efficiently refilling smaller cylinders (targets) from larger cylinders (sources). It is available with two, three, four, five, or six source valves, along with one or two target valves, and includes a safety pressure release valve. Custom mounting solutions for this product are available for order. You can read this{" "}
        <a
          href="https://www.jems.com/ems-operations/ems-equipment-gear/introducing-the-flotec-transfill-cascade-system/"
          target="_blank"
          rel="noopener noreferrer"
          className="extra-link"
          style={{ color: "#059669", textDecoration: "underline" }}
        >
          Journal of Emergency Medical Services (JEMS) article
        </a>{" "}
        for more information on the Transfill Cascade System.
      </>
    ),
  },
  {
    id: 6,
    name: "Ingage Regulator",
    price: 24.99,
    img: "TESTDEMO/P-DR81332.png",
    additionalImages: [
      "/TESTDEMO/Ingage_with_hose.png",
      "/TESTDEMO/P-DR81332.png",
      "/TESTDEMO/P-Ingage_blue.png"
    ],
    specifications: {
      "Material": "Anodized Aluminum, Brass, Plated Brass",
      "Registration": "FDA, Canada,and Singapore",
      "Construction": "All Metal",
      "Internal Pressure Gauge": "Yes",
      "Laser Drilled Orifice Plate with Integral Filter": "20-micron stainless steel filter",
      "Shape": "Dodecagon (12-sided)",
      "Flow Positions": "12-positions",
      "O-Ring Type Yoke Washer Seal": "Yes",
      "Swivel Yoke & Body": "Yes",
      "Outlet Connections": "Configurable Outlet options",
      "Custom Laser Etching": "Available upon request",
      "Flow Range": "1/32 LPM to 60 LPM",
      "MRI Conditional": "Yes",
    },
    brochure: "/BROCHURES/B-Regulator, InGage (2024-05-21) (Rev. A).docx.pdf",
    description: "The Flotec InGage Regulator is a versatile medical gas regulator featuring an integrated, field-resettable pressure gauge with a color-coded 0–3000 PSI display. Designed for durability and customization, it offers a robust all-metal construction (available in anodized aluminum or plated brass), a unique 12-sided anti-roll shape, and dual filtration with both brass and stainless steel sintered filters. With 12 flow positions, support for 9 medical gases, and multiple pressure, color, and outlet configurations, it delivers precise and reliable performance across a wide range of demanding environments."
  },
  {
    id: 7,
    name: "RW Regulator",
    price: 24.99,
    img: "TESTDEMO/RR813.png",
    specifications: {
      "Material": "Anodized Aluminum",
      "Registration": "USA, Canada, Austrailia, Singapore",
      "External Pressure Gauge": "Yes",
      "Laser Drilled Orifice Plate with Integrated Filter": "Yes",
      "O-Ring Type Yoke Washer Seal": "Yes",
      "Custom Laser Etching": "Available upon request",
      "Flow Range": "1/32 LPM to 60 LPM",
    },
    brochure: "/BROCHURES/B-Ambulance Respiratory Systems (RW) (2024-06-10) (Rev. B).docx.pdf",
    description: "The Flotec medical gas regulator has a 20 micron sintered metal inlet filter and a single stage, piston type, back pressure compensated, pressure reducer cartridge with an internal relief valve. The “click style” flowmeter module offers 12 flow settings, and unlike the Thorpe tube style, will operate in any position or while moving. A complete range of CGA or international inlet and outlet connections are available. The “modular” design allows the user to customize the regulator so that it will fit almost any need exactly."
  },
  {
    id: 8,
    name: "Hose Assemblies",
    price: 24.99,
    code: "true",
    img: "TESTDEMO/HoseAssembly/hose-removed-bg.png",
    brochure: "/BROCHURES/B-Ambulance Respiratory Systems (RW) (2024-06-10) (Rev. B).docx.pdf",
    description: "Flotec hose assemblies are built to provide reliable, gas-specific connections for a wide range of medical applications. Each assembly is fully configurable, allowing users to select the exact hose material, fitting styles, and overall length required for their system. All hoses and fittings follow industry-standard gas designations and color conventions to ensure compatibility, safety, and ease of use."
  },
];

export default products;
